import React,{useEffect, useState,useRef} from 'react'
import {connect } from 'react-redux';
import { setUserDetails} from './OrganizationPortalSlice';
import OrgFooterButtons from './OrgFooterButtons';
import ReactSelect from '../../Shared/ReactSelect/ReactSelect';


function DistributionCenter(props) {
  const [error, setError] = useState();
  const [selectedCenter, setSelectedCenter] = useState(props.userDetails.selectedDCenter);

  const goToNextPage=()=>{
   if(selectedCenter==""){
      setError('אנא בחר מרכז חלוקה')
      return false;
    }else{
      props.setUserDetails({...props.userDetails, selectedDCenter:selectedCenter})
      return true;
    }
  }

  const onChange=async(val)=>{
    if(val!==""){
      setError("");
      setSelectedCenter(val)
    }
  }


  return (
    <div className='step-page_S '>
      <div className='M_Title'> היכן תרצו לבצע את האיסוף?</div>
      <div className='distributionCenter'>

          <ReactSelect
                    error={error}
                    getOptionLabel={(option) =>option}
                    getOptionValue={(option) => option}
                    placeholder={selectedCenter || ' מרכזי חלוקה'}
                    value={selectedCenter}
                    name='distribution center'
                    options={props.orgDetails.distributionCenters}
                    onChange={(dCenter) =>{ onChange(dCenter)} }
        />
    </div>
      <OrgFooterButtons onContinue={()=>goToNextPage()} />
    </div>
  );
}

const mapStateToProps = (state) => ({
  userDetails: state.organizationPortal.userDetails,
  currentStep: state.organizationPortal.steps.current,
  orgDetails: state.organizationPortal.orgDetails,

});

const mapDispatchToProps = {
  setUserDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(DistributionCenter);
